'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularResource = require('angular-resource');

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularCookie = require('angular-cookie');

var _angularCookie2 = _interopRequireDefault(_angularCookie);

var _components = require('./components/components');

var _components2 = _interopRequireDefault(_components);

var _app = require('./app.component');

var _app2 = _interopRequireDefault(_app);

require('bootstrap/dist/css/bootstrap.min.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('app', [_angularUiRouter2.default, _components2.default, _angularResource2.default, _angularCookie2.default]).config(function ($locationProvider) {
  "ngInject";
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode

  $locationProvider.html5Mode(false).hashPrefix('');
}).component('app', _app2.default);


// WEBPACK FOOTER //
// ./client/app/app.js